module.exports = __webpack_public_path__ + "static/media/LOGO_COMPARA_CORSI_COLOR-2048x289.a7d20eeb.webp";